import { Component, inject, OnInit } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { ActivatedRoute, RouterOutlet } from '@angular/router';
import { FooterComponent } from '@infodocs/shared/components/footer/footer.component';
import { CustomHeaderCcfoComponent } from '@infodocs/shared/components/header/custom-header-ccfo/custom-header-ccfo.component';
import {
	CustomHeaderLegaleseComponent
} from '@infodocs/shared/components/header/custom-header-legalese/custom-header-legalese.component';
import { HeaderComponent } from '@infodocs/shared/components/header/header.component';
import { PublicHeaderCtaComponent } from '@infodocs/shared/components/header/public-header-cta/public-header-cta.component';
import { PublicHeaderLoginComponent } from '@infodocs/shared/components/header/public-header-login/public-header-login.component';
import { of } from 'rxjs';

@Component({
	selector: 'app-public-pages-wrapper',
	imports: [
		HeaderComponent,
		RouterOutlet,
		FooterComponent,
		PublicHeaderLoginComponent,
		PublicHeaderCtaComponent,
		CustomHeaderCcfoComponent,
		CustomHeaderLegaleseComponent
	],
	templateUrl: './public-pages-wrapper.component.html',
	styleUrl: './public-pages-wrapper.component.scss'
})
export class PublicPagesWrapperComponent {
	protected readonly headerType = toSignal(
		(inject(ActivatedRoute).firstChild?.data ?? of({ headerType: 'default' }))
	)
}
